import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AggregateDataSetFieldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AggregateDataSetField",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.83 30H3.17a1.168 1.168 0 0 1-.83-1.99L14.35 16 2.34 3.99c-.33-.33-.43-.84-.25-1.27S2.7 2 3.17 2h25.67c.64 0 1.17.52 1.17 1.17v4.88c0 .64-.52 1.17-1.17 1.17s-1.17-.52-1.17-1.17V4.34H5.98l10.84 10.84c.46.46.46 1.19 0 1.65L5.98 27.67h21.68v-3.71c0-.64.52-1.17 1.17-1.17s1.17.52 1.17 1.17v4.88c0 .64-.52 1.17-1.17 1.17Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.57 31.86H6c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.3.12-.59.33-.81l10.62-10.62L5.19 5.24c-.21-.21-.33-.5-.33-.81V1C4.86.37 5.37-.14 6-.14h20.57c.63 0 1.14.51 1.14 1.14v4.57a1.14 1.14 0 1 1-2.28 0V2.14H7.14v1.81l11.09 11.09a1.16 1.16 0 0 1 0 1.62L7.14 27.75v1.81h18.29v-3.43a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14Z"
      })
    })
  }));
};
AggregateDataSetFieldIcon.displayName = 'AggregateDataSetFieldIcon';